import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@partikelart/portal/data-access-auth";
import { ENV_CONFIG } from "../app.token";

/**
 * Gate for protected routes. Unauthenticated users are sent to /login.
 *
 * Bypassed for demo builds (no IdP at all) and static-API-key deployments
 * (machine identity attached by portalApiInterceptor instead).
 */
export const authGuard: CanActivateFn = () => {
	const env = inject(ENV_CONFIG);
	if (env.demo || env.portalApiKey) return true;

	const authService = inject(AuthService);
	if (authService.hasValidToken()) return true;

	return inject(Router).createUrlTree(["/login"]);
};
